/**
 * @file コンポーネント：見出し スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledHeadline = styled.div`
    margin-bottom: 12px;

    &[data-font-size="small"] {
        margin-bottom: 8px;
    }

    > * {
        font-weight: bold;
        font-size: 16px;
        line-height: 20px;

        &[data-font-size="xSmall"] {
            line-height: 14px;
        }

        &[data-font-size="small"] {
            line-height: 16px;
        }

        &[data-font-size="large"] {
            line-height: 28px;
        }

        &[data-font-size="xLarge"] {
            line-height: 32px;
        }

        &[data-font-weight="normal"] {
            font-weight: normal;
        }

        &[data-on-color="gray"] {
            color: #000000;
        }

        &[data-on-color="main"] {
            color: #ffffff;
        }

        &[data-on-color="sub"] {
            color: #ffffff;
        }

        &[data-on-color="white"] {
            color: #212121;
        }
    }
`;
